{
    "(save {highestYearlyDiscount}%)": "(poupe {highestYearlyDiscount}%)",
    "{amount} days free": "{amount} dias gratuitos",
    "{amount} off": "Desconto de {amount}",
    "{amount} off for first {number} months.": "Desconto de {amount} nos primeiros {number} meses.",
    "{amount} off for first {period}.": "Desconto de {amount} durante o primeiro {period}.",
    "{amount} off forever.": "Desconto de {amount} para sempre.",
    "{discount}% discount": "{discount}% de desconto",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} deixará de receber a newsletter {newsletterName}.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} deixará de receber emails quando alguém responder aos seus comentários.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} deixará de receber esta newsletter.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dias grátis",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Conta",
    "Account details updated successfully": "Detalhes da conta atualizados com sucesso",
    "Account settings": "Definições de conta",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Após o término do teste grátis, será cobrado o valor normal para o nível escolhido. Poderá sempre cancelar até esse momento, caso não deseje ser cobrado.",
    "Already a member?": "Já é membro?",
    "An error occurred": "Ocorreu um erro",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Ocorreu um erro inesperado. Por favor tente novamente ou <a>contacte o suporte</a> se o erro persistir.",
    "Back": "Voltar",
    "Back to Log in": "Voltar ao login",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Black Friday",
    "Bluesky": "",
    "Cancel anytime.": "Cancele a qualquer momento.",
    "Cancel subscription": "Cancelar subscrição",
    "Canceled": "",
    "Cancellation reason": "Motivo para o cancelamento",
    "Change": "Alterar",
    "Change plan": "Alterar plano",
    "Check spam & promotions folders": "Verifique a pasta de spam e promoções",
    "Check with your mail provider": "Entre em contacto com o seu serviço de email",
    "Check your inbox to verify email update": "",
    "Choose": "Escolher",
    "Choose a different plan": "Escolha um plano diferente",
    "Choose a plan": "Escolha um plano",
    "Choose your newsletters": "Escolha as suas newsletters",
    "Click here to retry": "Clique aqui para tentar novamente",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Fechar",
    "Code": "",
    "Comment preferences updated.": "Preferências de comentários atualizadas.",
    "Comments": "Comentários",
    "Complimentary": "Cortesia",
    "Confirm": "Confirmar",
    "Confirm cancellation": "Confirmar cancelamento",
    "Confirm subscription": "Confirmar subscrição",
    "Contact support": "Contactar suporte",
    "Continue": "Continuar",
    "Continue subscription": "Continuar subscrição",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Não foi possível registar. O link de login expirou.",
    "Could not update email! Invalid link.": "Não foi possível atualizar o email! Link inválido.",
    "Create a new contact": "Criar novo contacto",
    "Current plan": "Plano atual",
    "Delete account": "Eliminar a conta",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Não era essa a intenção? Gerir preferências <button>aqui</button>.",
    "Don't have an account?": "Não tem conta?",
    "Edit": "Editar",
    "Email": "Email",
    "Email confirmation link expired.": "",
    "Email newsletter": "Newsletter",
    "Email newsletter settings updated": "",
    "Email preferences": "Preferências de email",
    "Email preferences updated.": "",
    "Emails": "Emails",
    "Emails disabled": "Email desativado",
    "Ends {offerEndDate}": "Termina em {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "Insira o seu endereço de email",
    "Enter your name": "Insira o seu nome",
    "Error": "Erro",
    "Expires {expiryDate}": "Expira {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Erro ao cancelar a subscrição, por favor tente de novo",
    "Failed to log in, please try again": "Erro ao fazer login, por favor tente de novo",
    "Failed to log out, please try again": "Erro ao fazer logout, por favor tente de novo",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Erro a processar o checkout, por favor tente de novo",
    "Failed to send magic link email": "",
    "Failed to send verification email": "Erro ao enviar o email de verificação",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "Erro ao atualizar dados da conta",
    "Failed to update account details": "Erro ao atualizar detalhes da conta",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "Erro ao atualizar a subscrição, por favor tente de novo",
    "Failed to verify code, please try again": "",
    "Forever": "Para sempre",
    "Free Trial – Ends {trialEnd}": "Período de Teste Gratuito - Termina {trialEnd}",
    "Get help": "Obter ajuda",
    "Get in touch for help": "Entre em contacto para obter ajuda",
    "Get notified when someone replies to your comment": "Ser notificado quando alguém responde a um dos meus comentários",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Dar feedback a este artigo",
    "Help! I'm not receiving emails": "Ajuda! Não estou a receber emails",
    "Here are a few other sites you may enjoy.": "Aqui estão mais alguns sites que poderá gostar.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Se uma newsletter for marcada como spam, os emails serão automaticamente desativados para esse endereço para garantir que não receberá mais mensagens indesejadas.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Se a queixa de spam foi acidental, ou se gostaria de começar a receber emails novamente, pode voltar a subscrever os emails clicando no botão no ecrã anterior.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Se cancelar a sua subscrição agora, continuará a ter acesso até {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Se tem uma conta de email corporativa ou governamental, contacte o seu departamento de TI e peça-lhes para permitir a receção de emails de {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Um link de acesso foi enviado para o seu email. Se o email não chegar dentro de 3 minutos, verifique a pasta de spam/lixo do seu email.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Se gostaria de começar a receber emails novamente, os próximos passos são verificar o seu endereço de email registado para verificar se há algum problema e, em seguida, clicar para voltar a subscrever no ecrã anterior.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Se não está a receber a newsletter por email que subscreveu, aqui estão algumas questões a verificar.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Se completou todas estas verificações e ainda não está a receber emails, envie um email para {supportAddress} para obter apoio.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "No caso de uma falha permanente ser recebida ao tentar enviar uma newsletter, os emails serão desativados na conta.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "No seu email, adicione {senderEmail} à sua lista de contactos. Esta ação indica ao seu fornecedor de email que os emails enviados a partir deste endereço devem ser confiáveis.",
    "Invalid email address": "Email inválido",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Menos como este",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Certifique-se de que os emails não estão a acabar acidentalmente nas pastas de Spam ou das promoções da sua caixa de entrada. Se estiverem, clique em \"Marcar como não spam\" e/ou \"Mover para a caixa de entrada\".",
    "Manage": "Gerir",
    "Maybe later": "Talvez mais tarde",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Adesões indisponíveis, entre em contacto com o reponsável do site para aceder.",
    "month": "mês",
    "Monthly": "Mensalmente",
    "More like this": "Mais como este",
    "More options": "",
    "Name": "Nome",
    "Need more help? Contact support": "Precisa de mais ajuda? Entre em contacto com o suporte",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "As newsletters podem ser desativadas na sua conta por dois motivos: um email anterior foi marcado como spam, ou a tentativa de enviar um email resultou numa falha permanente (bounce).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Não está a receber emails?",
    "Now check your email!": "Verifica o teu email agora!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Se depois de ser inscrever novamente, os emails não chegaram à sua caixa de entrada, verifique por favor a sua pasta de spam. Alguns provedores de mail têm disponível um registro de reclamações anteriores de spam e continuarão a sinalizar emails. Se isso acontecer, marque a newsletter mais recente como 'Não é spam' para movê-la de volta para sua caixa de entrada principal.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Falha permanente (bounce)",
    "Phone number": "Número de telefone",
    "Plan": "Plano",
    "Plan checkout was cancelled.": "Plano de checkout foi cancelado.",
    "Plan upgrade was cancelled.": "Atualização de plano foi cancelada.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Entre for favor em contacto com {supportAddress} de modo a ajustar a sua subscrição complementar.",
    "Please enter {fieldName}": "Insira por favor {fieldName} ",
    "Please fill in required fields": "Preencha os campos obrigatórios",
    "Podcasts": "",
    "Re-enable emails": "Reativar emails",
    "Recommendations": "Recomendações",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Renove por {price}",
    "Resume subscription": "",
    "Retry": "Tente novamente",
    "Save": "Guardar",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send an email and say hi!": "Envie um email e diga olá!",
    "Send an email to {senderEmail} and say hello. This can also help signal to your mail provider that emails to and from this address should be trusted.": "Envie um email para {senderEmail} e diga olá. Isso também pode ajudar a sinalizar ao seu provedor de email que os emails de e para este endereço devem ser confiáveis.",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "A enviar o link de acesso...",
    "Sending...": "A enviar...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "Mostrar todos",
    "Sign in": "Entrar",
    "Sign out": "Sair",
    "Sign up": "Registar",
    "Signup error: Invalid link": "Erro de inscrição: ligação inválida",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Temos um erro em mãos, tente por favor mais tarde.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Desculpe, mas isso não funcionou.",
    "Spam complaints": "Reclamações de spam",
    "Start {amount}-day free trial": "Iniciar teste grátis de {amount} dias",
    "Starting {startDate}": "Começar em {startDate}",
    "Starting today": "Começar hoje",
    "Submit feedback": "Enviar avaliação",
    "Subscribe": "Inscrever-se",
    "Subscribed": "Inscrito",
    "Subscription plan updated successfully": "",
    "Success": "Sucesso",
    "Success! Check your email for magic link to sign-in.": "Sucesso! Verifique o seu email para o link mágico de acesso.",
    "Success! Your account is fully activated, you now have access to all content.": "Sucesso! A sua conta está totalmente ativada, agora tem acesso a todo o conteúdo.",
    "Success! Your email is updated.": "Sucesso! O seu email foi atualizado.",
    "Successfully unsubscribed": "Subscrição cancelada com sucesso",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Obrigado por subscrever. Antes de inicar as suas leituras, encontrará de seguida outros sites que poderá gostar. ",
    "Thank you for your support": "Obrigado pelo seu apoio.",
    "Thank you for your support!": "Obrigado pelo seu apoio!",
    "Thanks for the feedback!": "Obrigado pela avaliação!",
    "That didn't go to plan": "Algo não correu como planeado",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "O endereço de email que temos disponível para si é {memberEmail} — se desejar alterá-lo, poderá fazê-lo na sua <button>área de configurações da conta</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Houve um problema ao enviar sua avaliação. Tente novamente mais tarde por favor.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "Houve um problema ao processar o seu pagamento. Tente novamente por favor.",
    "There was an error sending the email, please try again": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "O acesso a este site é feito apenas por convite. Entre em contacto com o proprietário para obter acesso.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Este site não está a aceitar pagamentos de momento",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Para completar o registo, clique no link de confirmação enviado para a sua caixa de entrada. Se não o receber dentro de 3 minutos, verifique a sua pasta de spam!",
    "To continue to stay up to date, subscribe to {publication} below.": "Para continuar a par das novidades, subscreva o {publication} aqui.",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Experimente grátis por {amount} dias, depois {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Desbloqueie o acesso a todas as newsletters tornando-se um assinante pago.",
    "Unsubscribe from all emails": "Cancelar subscrição de todos os emails",
    "Unsubscribed": "Subscrição cancelada",
    "Unsubscribed from all emails.": "Subscrição de todos os emails cancelada.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Cancelar a subscrição dos emails não cancelará a sua assinatura paga de {title}",
    "Update": "Atualizar",
    "Update your preferences": "Atualizar as suas preferências",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Link de verificação enviado, verifique o seu email",
    "Verify your email address is correct": "Verifique se o endereço de email está correto",
    "Verifying...": "",
    "View plans": "Ver planos",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Não conseguimos cancelar a sua inscrição, visto que o email não foi encontrado. Por favor, entre em contato com o proprietário do site.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Bem-vindo de volta, {name}!",
    "Welcome back!": "Bem-vindo de volta!",
    "Welcome to {siteTitle}": "Bem-vindo ao {siteTitle}",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Quando a caixa de entrada rejeita um email, esse fenómeno é apelidado de bounce. Em muitos casos, tem carácter temporário. No entanto, em alguns casos, um email com falha pode ser retornado como uma falha permanente quando um endereço de email é inválido ou não existe.",
    "Why has my email been disabled?": "Por que razão o meu email foi desativado?",
    "X (Twitter)": "",
    "year": "ano",
    "Yearly": "Anualmente",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Atualmente tem uma assinatura gratuita, faça um upgrade para uma assinatura paga para ter acesso completo.",
    "You have been successfully resubscribed": "A sua subscrição foi renovada com sucesso",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Não está a receber emails atualmente",
    "You're not receiving emails": "Não está a receber emails",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Não está a receber emails porque, classificou uma mensagem recente como spam, ou as mensagens não puderam ser entregues no endereço de email que forneceu.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Registou-se com sucesso.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Subscreveu com sucesso <strong>{siteTitle}</strong>",
    "Your account": "A sua conta",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "O seu feedback ajudará a decidir o conteúdo que será publicado no futuro.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "A sua assinatura expirará em {expiryDate}",
    "Your subscription will renew on {renewalDate}": "A sua assinatura será renovada em {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "A sua assinatura começará em {subscriptionStart}"
}
